import { useState } from 'react'

import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

interface FilterZipProps {
  selectedZipCodes: string[]
  onChangeZipCodes: (zipCodes: string[]) => void
}

export default function FilterZip({ selectedZipCodes, onChangeZipCodes }: FilterZipProps) {
  const [inputValue, setInputValue] = useState('')
  const [showWarning, setShowWarning] = useState(false)
  const maxInputLength = 10

  const handleBlur = () => {
    const trimmedValue = inputValue.trim()
    if (trimmedValue && !selectedZipCodes.includes(trimmedValue)) {
      onChangeZipCodes([...selectedZipCodes, trimmedValue])
      setInputValue('')
    }
  }

  return (
    <Autocomplete
      value={selectedZipCodes}
      multiple
      filterSelectedOptions
      freeSolo
      options={[]}
      getOptionLabel={(option) => `${option}`}
      onChange={(_, selectedZipCodes) => onChangeZipCodes(selectedZipCodes as string[])}
      inputValue={inputValue}
      onBeforeInput={() => {
        if (inputValue.length === maxInputLength) {
          setShowWarning(true)
        }
      }}
      onInputChange={(_, value) => {
        setShowWarning(false)
        setInputValue(value)
      }}
      onBlur={handleBlur}
      ChipProps={{ color: 'primary', variant: 'outlined' }}
      renderInput={(params) => (
        <TextField
          {...params}
          color="primary"
          variant="outlined"
          label="ZIP Code"
          helperText={
            showWarning
              ? `ZIP codes cannot be more than ${maxInputLength} characters long.`
              : 'Press Enter to add more ZIP codes'
          }
          error={showWarning}
          inputProps={{
            ...params.inputProps,
            maxLength: maxInputLength,
          }}
        />
      )}
    />
  )
}
